import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { companies } from 'sections/Events/AnnualConferenceAttendeesList/data';
import styles from 'sections/Events/AnnualConferenceAttendeesList/components/SectionCompanies/SectionCompanies.module.scss';

const cn = classNames.bind(styles);

const SectionCompanies = (): ReactElement => {
  return (
    <section className={cn('companies')}>
      <div className={cn('container')}>
        <div className={cn('companies__list')}>
          <div className={cn('companies__list-item')}>
            <div className={cn('companies__list-item-name-box')}>
              <span className={cn('companies__list-item-name', 'title')}>Company</span>
            </div>
            <div className={cn('companies__list-item-name-box')}></div>
            <div className={cn('companies__list-item-name-box')}>
              <span className={cn('companies__list-item-name', 'title')}>Country</span>
            </div>
            <div className={cn('companies__list-item-name-box')}></div>
          </div>
          {companies.map((item) => {
            return (
              <div key={item['Name']} className={cn('companies__list-item')}>
                <div className={cn('companies__list-item-name-box')}>
                  <span className={cn('companies__list-item-name')}>{item['Name']}</span>
                </div>
                <div className={cn('companies__list-item-logo-box')}>
                  <img
                    className={cn('companies__list-item-logo')}
                    src={item['Logo'] || 'https://via.placeholder.com/40'}
                    alt={item['LogoAlt'] || 'Logo'}
                  />
                </div>
                <div className={cn('companies__list-item-country-box')}>
                  <span className={cn('companies__list-item-country')}>{item['Country']}</span>
                </div>
                <div className={cn('companies__list-item-flag-box')}>
                  <img
                    src={item['Flag'] || 'https://via.placeholder.com/40'}
                    alt={item['FlagAlt'] || 'Flag'}
                    className={cn('companies__list-item-flag')}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SectionCompanies;